module.exports = __webpack_public_path__ + "img/nav04_h.ecd71591.png";